import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { customModalStyles } from "../../../_shared/components/Modal/ModalStyles";
import ReturnsAndVolumeModalSection from "./ticker-modal/components/ReturnsAndVolumeModalSection";
import TickerModalHeader from "./ticker-modal/components/TickerModalHeader";
import OverallVolatilityIndicatorSection from "./ticker-modal/components/OverallVolatilityIndicatorSection";
import ShortInterestStats from "./ticker-modal/components/ShortInterestStats";
import InsiderAndCorrections from "./ticker-modal/components/InsiderAndCorrections";
import {
  usCurrency,
  noDecimals,
  usdCurrency,
} from "../../../_shared/helpers/formatting";
import "./TickerModal.scss";
import {
  PriceChart,
  TradingRange,
  RealizedVolatility,
  Beta,
  PriceReturns,
  ShortInterest,
  MomentumIndicator,
  ImpliedVolatility,
  Volume,
} from "./ticker-modal/components/Chart";
import MoneylineModal from "./MoneylineModal";

Modal.setAppElement("#root");

function TickerModal(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [chartDisplay, setChartDisplay] = useState("Trading-Range-Chart");
  const [moneylineModal, setMoneylineModal] = useState(false);
  const [imageExists, setImageExists] = useState(true);
  const timeoutRef = useRef(null);

  //Open/close 'Ticker Modal' and set 'Price Chart' as default chart display.
  function clickModal() {
    setIsOpen(!modalIsOpen);
    try {
      props.setDisableDeleteContextMenu(!modalIsOpen);
    } catch (err) {
      // console.log(err);
    }
    setChartDisplay("Trading-Range-Chart");
  }
  const momoDict = {
    NEUTRAL: "hold",
    BEARISH: "sell",
    BULLISH: "buy",
  };
  const moneylineStatsObj =
    props.cell.row.original.moneyline_stats?.[
      `tr_${localStorage.getItem("vip-view") === "oversold" ? "buy" : "sell"}`
    ]?.[`st_${momoDict[props.cell.row.original.algo_daily_30D_ST_MOMENTUM]}`]?.[
      `mt_${momoDict[props.cell.row.original.algo_daily_90D_MT_MOMENTUM]}`
    ];
  return (
    <div className="ticker-cell">
      <div
        className="guidedTour3Click guidedTour4"
        onClick={clickModal}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          textAlign: "left",
          alignItems: "flex-start",
          gap: 5,
          marginLeft: localStorage.getItem("view") !== "advanced" ? 0 : -31,
        }}
        onMouseEnter={() => {
          if (props.bullseye) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
              setMoneylineModal(true);
            }, 1000);
          }
        }}
        onMouseLeave={() => {
          if (props.bullseye) {
            clearTimeout(timeoutRef.current);
          }
        }}
      >
        {props.cell.column?.Header === "Ticker" &&
        localStorage.getItem("view") !== "advanced" &&
        imageExists ? (
          <img
            className={"tickerImage"}
            style={{
              height: props.compactMode ? 26 : 40,
              width: props.compactMode ? 26 : 40,
              borderRadius: 5,
              marginTop: -5,
            }}
            src={`https://files.mylongbow.com/icons/${
              props.cell.row.original.ticker.split(" ")[0]
            }.jpeg`}
            onError={(e) => {
              setImageExists(false);
              e.target.src =
                "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
            }}
          />
        ) : (
          <div style={{ width: props.compactMode ? 26 : 40 }} />
        )}
        {props.cell.column?.Header !== "Description"
          ? props.cell.value?.split(" ")[0]
          : props.cell.value}
      </div>
      {props.bullseye && (
        <MoneylineModal
          cell={props.cell}
          moneylineStatsObj={moneylineStatsObj}
          moneylineModal={moneylineModal}
          setMoneylineModal={setMoneylineModal}
        />
      )}
      {modalIsOpen && (
        <Modal
          // overlayClassName={"ReactModal__Overlay"}
          isOpen={modalIsOpen}
          onRequestClose={clickModal}
          style={customModalStyles}
          contentLabel="Ticker Modal"
        >
          {/* First row (Closing/Last Price, Trading Range, Longbow Core Signal, and Beta) */}
          <TickerModalHeader
            cell={props.cell}
            split={props.split}
            ratio={props.ratio}
            beforeSplit={props.beforeSplit}
            afterSplit={props.afterSplit}
            algo={props.cell.row.original.algo}
            clickModal={clickModal}
            original={props.cell.row.original}
            setChartDisplay={setChartDisplay}
            chartDisplay={chartDisplay}
            planInterval={props.planInterval}
            closingDate={props.closingDate}
            updatedDate={props.updatedDate}
            noDecimals={noDecimals}
            usCurrency={usCurrency}
            usdCurrency={usdCurrency}
          />
          <div className="modal-content" style={{ width: 900 }}>
            <div className="top-half">
              <div className="section1">
                {/* Second row (Momentum Indicator, and Implied/Realized Volatility) */}
                <OverallVolatilityIndicatorSection
                  original={props.cell.row.original}
                  setChartDisplay={setChartDisplay}
                  chartDisplay={chartDisplay}
                  algo={props.cell.row.original.algo}
                  planInterval={props.planInterval}
                  setPlanInterval={props.setPlanInterval}
                  noDecimals={noDecimals}
                  usCurrency={usCurrency}
                  usdCurrency={usdCurrency}
                />
                {/* All charts */}
                {chartDisplay === "Price-Chart" ? (
                  <>
                    <PriceChart ticker={props.cell.row.original.ticker} />
                  </>
                ) : chartDisplay === "Trading-Range-Chart" ? (
                  <TradingRange ticker={props.cell.row.original.ticker} />
                ) : chartDisplay === "Beta-Chart" ? (
                  <>
                    {/* <OldBeta
                      value={props.cell.row.original.ticker}
                      planInterval={props.planInterval}
                      setPlanInterval={props.setPlanInterval}
                    /> */}
                    <Beta ticker={props.cell.row.original.ticker} />
                  </>
                ) : chartDisplay === "Short-Interest-Chart" ? (
                  <>
                    {/* <ShortInterestStatsChart
                    value={props.cell.row.original.ticker}
                    planInterval={props.planInterval}
                    setPlanInterval={props.setPlanInterval}
                  /> */}
                    <ShortInterest ticker={props.cell.row.original.ticker} />
                  </>
                ) : chartDisplay === "Implied-Volatility-Chart" ? (
                  <>
                    {/* <OldImpliedVolatility
                    value={props.cell.row.original.ticker}
                    planInterval={props.planInterval}
                    setPlanInterval={props.setPlanInterval}
                  /> */}
                    <ImpliedVolatility
                      ticker={props.cell.row.original.ticker}
                    />
                  </>
                ) : chartDisplay === "Realized-Volatility-Chart" ? (
                  <RealizedVolatility ticker={props.cell.row.original.ticker} />
                ) : chartDisplay === "PRICE RETURNS-Chart" ? (
                  <>
                    {/* <Returns
                    value={props.cell.row.original.ticker}
                    planInterval={props.planInterval}
                    setPlanInterval={props.setPlanInterval}
                  /> */}
                    <PriceReturns ticker={props.cell.row.original.ticker} />
                  </>
                ) : chartDisplay === "VOLUME-Chart" ? (
                  <>
                    {/* <OldVolume
                    value={props.cell.row.original.ticker}
                    planInterval={props.planInterval}
                    setPlanInterval={props.setPlanInterval}
                  /> */}
                    <Volume ticker={props.cell.row.original.ticker} />
                  </>
                ) : (
                  <>
                    {/* <MomentumIndicatorChart
                      value={props.cell.row.original.ticker}
                      planInterval={props.planInterval}
                      setPlanInterval={props.setPlanInterval}
                    /> */}
                    <MomentumIndicator
                      ticker={props.cell.row.original.ticker}
                    />
                  </>
                )}
              </div>
              {/* Right side of modal (Returns, Volume and Short Interest) */}
              <div
                className="section2"
                style={{ borderBottom: "1px solid #2e2e2e" }}
              >
                <ReturnsAndVolumeModalSection
                  title="PRICE RETURNS"
                  original={props.cell.row.original}
                  chartDisplay={chartDisplay}
                  setChartDisplay={setChartDisplay}
                />
                <ReturnsAndVolumeModalSection
                  title="VOLUME"
                  original={props.cell.row.original}
                  chartDisplay={chartDisplay}
                  setChartDisplay={setChartDisplay}
                />
                <div onClick={() => setChartDisplay("Short-Interest-Chart")}>
                  <ShortInterestStats
                    style={{ cursor: "pointer" }}
                    chartDisplay={chartDisplay}
                    original={props.cell.row.original}
                  />
                </div>
              </div>
            </div>
            {/* Bottom-half (Insider Transactions and USD Correlations) */}
            <InsiderAndCorrections
              value={props.cell.row.original.ticker}
              insiderTransactions={
                props.cell.row.original.insider_monthly_transaction
              }
            />
          </div>
        </Modal>
      )}
    </div>
  );
}
export default React.memo(TickerModal);
